export default "__VITE_ASSET__d27003b4__"